var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35135 3.88244H2.67568C1.75023 3.88244 1 4.63267 1 5.55812V10.5851C1 12.436 2.50045 13.9365 4.35135 13.9365H7.07432M4.35135 3.88244V0.950012M4.35135 3.88244H9.7973M7.07432 13.9365H9.7973C11.6482 13.9365 13.1486 12.436 13.1486 10.5851V5.55812C13.1486 4.63267 12.3984 3.88244 11.473 3.88244H9.7973M7.07432 13.9365V16.45M9.7973 3.88244V0.950012",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.4606ce8b3701af0a0036e4cd045474af.svg";
export { ForwardRef as ReactComponent };